import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const getPlainText = (htmlValue = "") => {
    if (typeof htmlValue !== "string") return "";

    if (typeof document === "undefined") {
        return htmlValue.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    }

    const container = document.createElement("div");
    container.innerHTML = htmlValue;
    const plainText = (container.textContent || container.innerText || "").trim();
    const quotePairs = { '"': '"', "'": "'" };
    const closingQuote = quotePairs[plainText[0]];

    return closingQuote && plainText.endsWith(closingQuote)
        ? plainText.slice(1, -1).trim()
        : plainText;
};

const CompanyDescription = () => {

    const companyDetail = useSelector((state) => state.companyReducer.company);
    const [company, setCompany] = useState(companyDetail);

    useEffect(() => {
        if (companyDetail) {
            setCompany(companyDetail);
        }
    }, [companyDetail]);

    return (
        <div className="max-w-5xl mx-auto py-8">
            {company ? (
                <div className="bg-white bg-opacity-75 p-6 space-y-4">
                    <h2 className="text-3xl font-bold text-[#002366] tracking-wider font-sans mb-4">
                        {`WHY ${company.name ? company.name.toUpperCase() : ""}?`}
                    </h2>
                    <p className="text-lg text-gray-700 font-serif leading-7 tracking-wide">
                        {getPlainText(company.description)}
                    </p>
                </div>
            ) : (
                <p className="text-lg text-gray-600">Loading company details...</p>
            )}
        </div>
    );
};

export default CompanyDescription;
